import React, { createContext, useContext, useState } from "react";

const VideoPlayerContext = createContext<{
  someIsPlaying: boolean;
  setSomePlaying: (bool: boolean) => void;
  isMuted: boolean;
  setIsMuted: (bool: boolean) => void;
  playingVideoRef: HTMLVideoElement | null;
  setPlayingVideoRef: (ref: HTMLVideoElement | null) => void;
}>({
  someIsPlaying: true,
  setSomePlaying: () => {},
  isMuted: false,
  setIsMuted: () => {},
  playingVideoRef: null,
  setPlayingVideoRef: () => {},
});

export const VideoPlayerProvider = ({ children }: { children: any }) => {
  const [someIsPlaying, setSomePlaying] = useState<boolean>(true);
  const [isMuted, setIsMuted] = useState(true);
  const [playingVideoRef, setPlayingVideoRef] =
    useState<HTMLVideoElement | null>(null);

  return (
    <VideoPlayerContext.Provider
      value={{
        someIsPlaying,
        setSomePlaying,
        isMuted,
        setIsMuted,
        playingVideoRef,
        setPlayingVideoRef,
      }}
    >
      {children}
    </VideoPlayerContext.Provider>
  );
};

export const useVideoPlayer = () => {
  const context = useContext(VideoPlayerContext);
  if (!context) {
    throw new Error("useMuted must be used within a MutedProvider");
  }
  return context;
};
